<template>
  <div class="man-hinh-dang-nhap">
    <div class="text-center mb-3">
      <img
        v-bind:alt="APP_TITLE"
        class="logo"
        src="../../assets/images/logo.png"
      />
    </div>
    <div class="color-blue-1 font-weight-bold text-center font-size-20">
      <span class="text-uppercase">
        {{ APP_TITLE }}
      </span>
    </div>
    <div class="login-box mt-4">
      <ValidationObserver ref="observer" tag="form">
        <b-form>
          <div v-if="!isRequireSetup2FA">
            <b-form-group class="required position-relative mb-0">
              <ValidationProvider
                :rules="`required_field:${TEN_DANG_NHAP}`"
                name="loginForm.ten_dang_nhap"
              >
                <div slot-scope="{ errors }">
                  <b-form-input
                    :class="{ 'is-danger': errors.length > 0 }"
                    @keyup.enter="dangNhap()"
                    id="ten_dang_nhap"
                    v-bind:placeholder="TEN_DANG_NHAP"
                    required
                    type="text"
                    v-model="loginForm.userName"
                  />
                  <p :class="{ error: errors.length > 0 }">{{ errors[0] }}</p>
                </div>
              </ValidationProvider>
              <div class="bieu-tuong-dang-nhap">
                <b-icon icon="person-fill" />
              </div>
            </b-form-group>
            <b-form-group class="required position-relative mb-0">
              <ValidationProvider
                :rules="`required_field:${MAT_KHAU}`"
                name="loginForm.mat_khau"
              >
                <div slot-scope="{ errors }">
                  <b-form-input
                    :class="{ 'is-danger': errors.length > 0 }"
                    @keyup.enter="dangNhap()"
                    id="mat_khau"
                    v-bind:placeholder="MAT_KHAU"
                    required
                    type="password"
                    v-model="loginForm.password"
                  />
                  <p :class="{ error: errors.length > 0 }">{{ errors[0] }}</p>
                </div>
              </ValidationProvider>
              <div class="bieu-tuong-dang-nhap">
                <b-icon icon="lock" />
              </div>
            </b-form-group>
          </div>
          <div class="auth-otp cursor-pointer text-center" v-else>
            <a href="#" class="mb-3 d-inline-block" @click="quayLai">
                    <span class="back">
                        <b-icon icon="arrow-left" /></span
                    ><span>Quay lại</span>
            </a>
            <div class="text-center mb-3">
              <div class="title-auth font-size-16">Xác minh hai bước</div>
              <div class="d-flex justify-content-center">
                <div style="width: 300px; font-size: 12px">
                  Để giữ an toàn cho tài khoản của bạn, hệ thống muốn đảm
                  bảo rằng bạn chính là người đang cố đăng nhập
                </div>
              </div>
              <div class="mt-3 user mb-2">
                      <span>
                        <svg
                          aria-hidden="true"
                          class="stUf5b"
                          fill="currentColor"
                          focusable="false"
                          width="20px"
                          height="20px"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm6.36 14.83c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33C4.62 15.49 4 13.82 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83zM12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6z"
                          ></path>
                        </svg>
                      </span>
                <span style="margin-left: 3px">{{ loginForm.userName }}</span>
              </div>
            </div>
            <div
              style="flex-direction: row"
              class="mb-2 d-flex justify-content-center"
            >
              <v-otp-input
                ref="otpInput"
                input-classes="otp-input"
                separator="-"
                :num-inputs="6"
                :should-auto-focus="true"
                :is-input-num="true"
                @on-change="handleOnChange"
                @on-complete="handleOnComplete"
              />
            </div>
          </div>
        </b-form>
      </ValidationObserver>
      <ModalAuthenticator ref="authenticator" @authenticator="authenticator" />
      <button v-if="isRequireSetup2FA"  :disabled="!isDisabledAuth"  @click="validateAuthenticator" class="btn dang-nhap-btn mt-4">Xác thực</button>
      <button v-else @click="dangNhap()" class="btn dang-nhap-btn mt-4">
        <span class="align-text-bottom">{{ BTN_DANGNHAP }}</span>
        <div class="lds-ring" v-show="laDangDangNhap">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </button>
    </div>
    <div class="copyright">{{ COPY_RIGHT }}</div>
    <BaseLoading :is-loading="loading" />
  </div>
</template>

<script>
import {
  getValueFromStorageByKey,
  LOCAL_STORAGE_KEY,
  removeValueToStorageByKey,
  setValueToStorageByKey
} from "@/utils/localStorage";
import * as message from "@/constants/message";
import { HTTP } from "@/api/http-common";
import { mapGetters } from "vuex";
import { COMMON_TEXT } from "@/constants/constants";
import { showMsgError } from "@/utils/commonUtils";
import forge from "node-forge";
import ModalAuthenticator from "./quan-tri-he-thong/ModalAuthenticator";
import BaseLoading from "../common/BaseLoading";
export default {
  name: "DangNhap",
  components: {BaseLoading, ModalAuthenticator},
  data() {
    return {
      loading: false,
      isXacThuc: null,
      isDisabledAuth: false,
      maXacThuc: null,
      isRequireSetup2FA: false,
      loginForm: {
        userName: "",
        password: ""
      },
      TEN_DANG_NHAP: COMMON_TEXT.FORM_LOGIN.TEN_DANG_NHAP,
      MAT_KHAU: COMMON_TEXT.FORM_LOGIN.MAT_KHAU,
      BTN_DANGNHAP: COMMON_TEXT.FORM_LOGIN.BTN_DANGNHAP,
      APP_TITLE: COMMON_TEXT.APP_TITLE,
      COPY_RIGHT: COMMON_TEXT.COPY_RIGHT,
      laDangDangNhap: false,
      publicKey: `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqhSQUwu11FG5JK3xZsyv
y/gbEOch0SzVKVz+iKYg13LRi2Wwp0yub4husPcNwV96f1jOCTnTOgFvsKEpKtdw
1qRJ4O1KEDgaf23Z4eXY1XnrzGo2KlVYjvvsFYYWeUOLX1xHvULVyCcCcDPCWWC0
KFS9S8wDiTf4t08cM6BaBihvALfUgBEFe9hKbzrwuQlmnRzHzsk/eW0fcrJ4wiYx
DiDrSfIBEOfrlZ1GpT4HqKP4q8AxwqBWDR9c5nwmGTqDezt3ErreOVWaDFeSokeI
JjiNNdyG0CsbuPnR7vz4F1aZHKaX2gJib3buZ4U+IfoaLrCN98gPKBvo6I5IESda
iQIDAQAB
-----END PUBLIC KEY-----`,
    };
  },
  computed: {
    ...mapGetters({
      isLogin: "common/isLogin"
    })
  },
  methods: {
    async handleOnComplete(value) {
      this.maXacThuc = await value
      await this.validateAuthenticator()
    },
    handleOnChange(value) {
      if (value.length === 6) {
        this.isDisabledAuth = true
      } else {
        this.isDisabledAuth = false
      }
    },
    quayLai() {
      this.isRequireSetup2FA = !this.isRequireSetup2FA
    },
    authenticator(res) {
      setValueToStorageByKey(
        LOCAL_STORAGE_KEY.ACCESS_TOKEN,
        res.data.accessToken
      );
      setValueToStorageByKey(
        LOCAL_STORAGE_KEY.REFRESH_TOKEN,
        res.data.refreshToken
      );
      setValueToStorageByKey(
        LOCAL_STORAGE_KEY.PERMISSIONS,
        res.data.listPermissions
      );
      let userInfo = res.data.userInformation;
      setValueToStorageByKey(LOCAL_STORAGE_KEY.USER_INFO, userInfo);
      this.$store.dispatch("common/setIsLogin", true);
      this.$store.dispatch("common/setUserInfo", userInfo);
      localStorage.setItem("isLogin", true);
      HTTP.defaults.headers = {
        Authorization: `Bearer ${getValueFromStorageByKey(
          LOCAL_STORAGE_KEY.ACCESS_TOKEN
        )}`,
        "Access-Control-Allow-Origin": "*"
      };
      //this.$store.dispatch("common/setPermission");
      if (res.data.expiresIn) {
        const minuteTimeout = res.data.AccessToken.ExpiresIn * 60 * 1000;
        setTimeout(() => {
          removeValueToStorageByKey(LOCAL_STORAGE_KEY.ACCESS_TOKEN);
          removeValueToStorageByKey(LOCAL_STORAGE_KEY.REFRESH_TOKEN);
          removeValueToStorageByKey(LOCAL_STORAGE_KEY.PERMISSIONS);
          removeValueToStorageByKey(LOCAL_STORAGE_KEY.USER_INFO);
          removeValueToStorageByKey(LOCAL_STORAGE_KEY.APP_ID);
        }, minuteTimeout);
      }
      this.$toasted.clear();
      this.$toasted.global.showSuccessMessage({
        message: message.DANG_NHAP_THANH_CONG
      });
      this.$router.push({
        //name: ROUTE_NAME.TRANG_CHU,
        path: `/`
      });
    },
    validateAuthenticator() {
      this.loading = true
      this.$store
          .dispatch('common/validateLogin', {
            twoFactorCode: this.maXacThuc,
          })
          .then((res) => {
            if (res.succeeded) {
              this.loading = false
              this.authenticator(res)
            }
          })
          .catch((error) => {
            this.loading = false
            this.$toasted.global.showErrorMessage({
              message: error.data.message || 'Có lỗi xảy ra'
            });
          })
    },
    async dangNhap() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }
      var rsa = forge.pki.publicKeyFromPem(this.publicKey);
      var encryptedPassword = window.btoa(rsa.encrypt(this.loginForm.password));
      const payload = {
        userName: this.loginForm.userName,
        password: encryptedPassword,
        environment: "Stagging"
      };
      this.$store
        .dispatch("common/login", payload)
        .then(res => {
          if (res.data.succeeded) {
            setValueToStorageByKey(
              LOCAL_STORAGE_KEY.ACCESS_TOKEN,
              res.data.data.accessToken
            );
            HTTP.defaults.headers = {
              Authorization: `Bearer ${getValueFromStorageByKey(
                LOCAL_STORAGE_KEY.ACCESS_TOKEN
              )}`,
              "Access-Control-Allow-Origin": "*"
            };
            this.isRequireSetup2FA = !res.data.data.isRequireSetup2FA
            if (res.data.data.isRequireSetup2FA) {
              this.isXacThuc = false
              this.$refs.authenticator.showModal({
                token: res.data.data.accessToken,
                isRequireSetup2FA: res.data.data.isRequireSetup2FA,
              })
            } else if (this.maXacThuc) {
              this.isXacThuc = true
            }
            // setValueToStorageByKey(
            //   LOCAL_STORAGE_KEY.ACCESS_TOKEN,
            //   res.data.data.accessToken
            // );
            // setValueToStorageByKey(
            //   LOCAL_STORAGE_KEY.REFRESH_TOKEN,
            //   res.data.data.refreshToken
            // );
            // setValueToStorageByKey(
            //   LOCAL_STORAGE_KEY.PERMISSIONS,
            //   res.data.data.listPermissions
            // );
            // let userInfo = res.data.data.userInformation;
            // setValueToStorageByKey(LOCAL_STORAGE_KEY.USER_INFO, userInfo);
            // this.$store.dispatch("common/setIsLogin", true);
            // this.$store.dispatch("common/setUserInfo", userInfo);
            // localStorage.setItem("isLogin", true);
            // HTTP.defaults.headers = {
            //   Authorization: `Bearer ${getValueFromStorageByKey(
            //     LOCAL_STORAGE_KEY.ACCESS_TOKEN
            //   )}`,
            //   "Access-Control-Allow-Origin": "*"
            // };
            // //this.$store.dispatch("common/setPermission");
            // if (res.data.expiresIn) {
            //   const minuteTimeout = res.data.AccessToken.ExpiresIn * 60 * 1000;
            //   setTimeout(() => {
            //     removeValueToStorageByKey(LOCAL_STORAGE_KEY.ACCESS_TOKEN);
            //     removeValueToStorageByKey(LOCAL_STORAGE_KEY.REFRESH_TOKEN);
            //     removeValueToStorageByKey(LOCAL_STORAGE_KEY.PERMISSIONS);
            //     removeValueToStorageByKey(LOCAL_STORAGE_KEY.USER_INFO);
            //     removeValueToStorageByKey(LOCAL_STORAGE_KEY.APP_ID);
            //   }, minuteTimeout);
            // }
            // this.$toasted.clear();
            // this.$toasted.global.showSuccessMessage({
            //   message: message.DANG_NHAP_THANH_CONG
            // });
            // this.$router.push({
            //   //name: ROUTE_NAME.TRANG_CHU,
            //   path: `/`
            // });
          } else {
            this.$toasted.clear();
            this.$toasted.global.showErrorMessage({
              message: res.data.message
            });
          }
        })
        .catch(error => {
          showMsgError("Tên đăng nhập hoặc mật khẩu không đúng");
        });
    }
  }
};
</script>
<style lang="scss">
  .otp-input {
    width: 35px;
    height: 35px;
    padding: 5px;
    margin: 0 7px;
    font-size: 14px;
    border-radius: 4px;
    border: 1px solid rgb(60, 64, 67);
    text-align: center;
    &.error {
      border: 1px solid red !important;
    }
    &:focus-visible {
      outline: auto 1px #0088cc;
    }
  }
  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .auth-otp {
    .title-auth {
      margin-bottom: 5px;
    }
    .user {
      border: 1px solid rgb(218, 220, 224);
      color: rgb(60, 64, 67);
      display: inline-block;
      padding: 3px 8px 3px 8px;
      border-radius: 15px;
      font-size: 12px;
      font-weight: 500;
    }
    .back {
      margin-right: 3px;
    }
  }
</style>
